import { NgClass } from '@angular/common'
import { Component, input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'lib-sentiment-text',
  imports: [NgClass],
  templateUrl: './sentiment-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './sentiment-text.component.scss',
})
export class SentimentTextComponent {
  readonly sentiment = input<'POSITIVE' | 'WARNING' | 'NEGATIVE' | 'NEUTRAL' | undefined>('NEUTRAL')
}
